// extracted by mini-css-extract-plugin
export default {"header":"Header_header__-ww7l","loginBlock":"Header_loginBlock__eQJBc"};